export const parseDataConfigurationSignalingToInput = (data) => {
  return {
    time_agent_1: data?.agentSignaling[0].time,
    time_agent_2: data?.agentSignaling[1].time,
    time_customer_1: data?.customerSignaling[0].time,
    time_customer_2: data?.customerSignaling[1].time,
    action_agent_1: data?.agentSignaling[0].type,
    action_agent_2: data?.agentSignaling[1].type,
    action_customer_1: data?.customerSignaling[0].type,
    action_customer_2: data?.customerSignaling[1].type
  };
};
